<template>
  <div class="header-image-uploader">
    <div class="pc-image" :class="pcImage || 'no-image'">
      <img class="image-previewer" :src="pcImagePath"/>
      <input
        v-show="false"
        ref="pcImageFile"
        type="file"
        :accept="acceptFileType && acceptFileType.join(',')"
        @change="handleImageFileChange(true)"/>
      <div class="uploader-mask" @click="handleUploaderClick(true)">
        <div class="uploader">
          <div class="add-btn">
            <i class="el-icon-circle-plus"></i>
          </div>
          <div class="tip-message">
            <div class="tip-title">{{ $t('common.upload.tipMessage.addHeaderImage.pc') }}</div>
            <div class=tip-subtitle>{{ pcTipMessage }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-image" :class="mobileImage || 'no-image'">
      <img class="image-previewer" :src="mobileImagePath"/>
      <input
        v-show="false"
        ref="mobileImageFile"
        type="file"
        :accept="acceptFileType && acceptFileType.join(',')"
        @change="handleImageFileChange(false)"/>
      <div class="uploader-mask" @click="handleUploaderClick(false)">
        <div class="uploader">
          <div class="add-btn">
            <i class="el-icon-circle-plus"></i>
          </div>
          <div class="tip-message">
            <div class="tip-title">{{ $t('common.upload.tipMessage.addHeaderImage.mobile') }}</div>
            <div class=tip-subtitle>{{ mobileTipMessage }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFilePath, uploadFile as uploadFileToCdn } from '@/utils/qiniu'

export default {
  props: {
    mobileImage: {
      required: true
    },
    pcImage: {
      required: true
    },
    acceptFileType: {
      required: false
    },
    rejectFileTypeMessage: {
      required: false
    },
    acceptFileSize: {
      required: false
    },
    rejectFileSizeMessage: {
      required: false
    },
    tipMessage: {
      required: false
    }
  },
  data () {
    return {
      oldFile: {
        pc: null,
        mobile: null
      },
      newFile: {
        pc: null,
        mobile: null
      }
    }
  },
  computed: {
    pcImagePath () {
      return getFilePath(this.pcImage)
    },
    mobileImagePath () {
      return getFilePath(this.mobileImage)
    },
    mobileTipMessage () {
      return this.tipMessage && this.tipMessage.mobile
    },
    pcTipMessage () {
      return this.tipMessage && this.tipMessage.pc
    }
  },
  created () {
    this.oldFile.pc = this.pcImage
    this.oldFile.mobile = this.mobileImage
  },
  methods: {
    handleUploaderClick (isPc) {
      let fileInput = null
      if (isPc) {
        fileInput = this.$refs.pcImageFile
      } else {
        fileInput = this.$refs.mobileImageFile
      }
      fileInput.click()
    },
    handleImageFileChange (isPc) {
      let fileInput = null
      if (isPc) {
        fileInput = this.$refs.pcImageFile
      } else {
        fileInput = this.$refs.mobileImageFile
      }
      const file = fileInput.files[0]
      if (!file) {
        return
      }
      if (this.acceptFileType && !this.acceptFileType.includes(file.type)) {
        this.$message.error({
          type: 'error',
          showClose: true,
          message: this.rejectFileTypeMessage
        })
        return
      }
      if (this.acceptFileSize && file.size > this.acceptFileSize) {
        this.$message.error({
          type: 'error',
          showClose: true,
          message: this.rejectFileSizeMessage
        })
        return
      }
      if (isPc) {
        this.newFile.pc = file
      } else {
        this.newFile.mobile = file
      }
      this.$emit('file-change', file, isPc)
    },
    async uploadAll (keyGenerator) {
      const pcFile = this.newFile.pc
      const mobileFile = this.newFile.mobile
      const pcFileKey = keyGenerator(pcFile, true)
      const mobileFileKey = keyGenerator(mobileFile, false)
      await this.uploadFile(pcFileKey, true)
      await this.uploadFile(mobileFileKey, false)
      return {
        pc: pcFile && pcFileKey,
        mobile: mobileFile && mobileFileKey
      }
    },
    async uploadFile (fileKey, isPc) {
      const file = isPc ? this.newFile.pc : this.newFile.mobile
      if (!file) {
        return
      }
      return uploadFileToCdn(file, fileKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-image-uploader {
  display: flex;
  height: 150px;
  margin-top: 20px;

  > div {
    background: #f7f7f7;
    position: relative;

    &.no-image {
      .image-previewer {
        display: none;
      }

      .uploader-mask {
        display: flex;
      }
    }

    &:not(.no-image):hover {
      .uploader-mask {
        display: flex;
        background: rgba($color: #f7f7f7, $alpha: 0.8);
      }
    }

    .image-previewer {
      width: 100%;
      height: 100%;
    }

    .uploader-mask {
      display: none;
      width: 100%;
      height: 100%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;

      .uploader {
        margin: auto;

        .add-btn {
          color: #0096cc;
          font-size: 46px;
        }

        .tip-message {
          margin-top: 5px;

          .tip-title {
            font-weight: bold;
            font-size: 14px;
          }

          .tip-subtitle {
            margin-top: 5px;
            color: #888888;
          }
        }
      }
    }
  }
  .pc-image {
    flex: 1;
  }
  .mobile-image {
    width: 230px;
    margin-left: 10px;
  }
}
</style>
